module.exports = {
	"chart": {
		"animation": false
	},
	"legend": {
		"labelFormat": "{name}: {y} %"
	},
	"plotOptions": {
		"series": {
			"animation": false
		}
	}
}